import GridCol from 'components/atoms/GridCol';
import React from 'react';
import Field from 'components/molecules/Field';
import Grid from 'components/atoms/Grid';
import commonService from 'services/commonService';
import Upload from '../Upload';
import 'styled-components/macro';
import { GroupFieldHeading, CompactSection, SectionHeader, FieldRow } from './configuration.styles';

function HeaderLines({ state, section, onChange = () => {} }) {
  const uploadImageToCloud = async file => {
    try {
      const formData = new FormData();
      formData.append('image', file);
      const response = await commonService.uploadImage(formData);
      return response;
    } catch (error) {
      return false;
    }
  };

  const deleteImageFromCloud = async img => {
    try {
      const response = await commonService.deleteImage({ fileName: img });
      return response;
    } catch (error) {
      return false;
    }
  };

  return (
    <CompactSection>
      <SectionHeader>
        <span className="material-icons-outlined" css="font-size: 18px;">
          receipt
        </span>
        Receipt Header Lines
      </SectionHeader>

      <Grid xs={1} sm={2} lg={2} colGap={20} rowGap={15}>
        <GridCol>
          <Upload
            allowPreview
            cloud
            maxFileSize={3}
            onChange={onChange}
            label="Logo (Header Line 1)"
            uploadBtnText="Upload Logo"
            name={`${section}.line_1`}
            uploadImageToCloud={uploadImageToCloud}
            deleteImageFromCloud={deleteImageFromCloud}
            value={state?.line_1}
          />
        </GridCol>

        <GridCol>
          <FieldRow>
            <Field
              sm
              name={`${section}.line_2`}
              type="text"
              label="Store Name (Line 2)"
              value={state?.line_2}
              onChange={onChange}
            />
          </FieldRow>
          <FieldRow>
            <Field
              sm
              name={`${section}.line_3`}
              type="text"
              label="Address Line 1 (Line 3)"
              value={state?.line_3}
              onChange={onChange}
            />
            <Field
              sm
              name={`${section}.line_4`}
              type="text"
              label="Address Line 2 (Line 4)"
              value={state?.line_4}
              onChange={onChange}
            />
          </FieldRow>
        </GridCol>

        <GridCol>
          <div css="background: white; padding: 12px; border-radius: 6px; border: 1px solid #e9ecef;">
            <GroupFieldHeading css="margin-bottom: 8px; font-size: 14px;">Header Line 5</GroupFieldHeading>
            <FieldRow>
              <Field
                sm
                name={`${section}.line_5.en`}
                type="text"
                label="English"
                value={state?.line_5.en}
                onChange={onChange}
              />
              <Field
                sm
                name={`${section}.line_5.fr`}
                type="text"
                label="French"
                value={state?.line_5.fr}
                onChange={onChange}
              />
            </FieldRow>
          </div>
        </GridCol>

        <GridCol>
          <div css="background: white; padding: 12px; border-radius: 6px; border: 1px solid #e9ecef;">
            <GroupFieldHeading css="margin-bottom: 8px; font-size: 14px;">Header Line 6</GroupFieldHeading>
            <FieldRow>
              <Field
                sm
                name={`${section}.line_6.en`}
                type="text"
                label="English"
                value={state?.line_6.en}
                onChange={onChange}
              />
              <Field
                sm
                name={`${section}.line_6.fr`}
                type="text"
                label="French"
                value={state?.line_6.fr}
                onChange={onChange}
              />
            </FieldRow>
          </div>
        </GridCol>
      </Grid>
    </CompactSection>
  );
}

export default HeaderLines;
